module.exports = __webpack_public_path__ + "img/aafmc-logo1.png";